import React, { useState, useEffect } from "react";
import { emailValidation, negativeNumberStringValidation, validatePhone } from "../Utils/validation";


function Input({ img, label, name, handleChange, branchDetail, submit }) {

  const [error, setError] = useState(false)




  const onChangeEnd = (event) => {
    handleChange(event)
  }

  useEffect(() => {
    let errorDublicate = error
    errorDublicate = false
    if (submit) {
      if (name === "mobileNo") {
        if (branchDetail[name].trim().length !== 0) {
          if (!validatePhone(branchDetail[name].trim())) {
            errorDublicate = true
          }
        }
        else
          errorDublicate = true
      }
      if (name === "emailId") {
        if (branchDetail[name].trim().length !== 0) {
          if (!emailValidation(branchDetail[name])) {
            errorDublicate = true
          }
        }
        else
          errorDublicate = true
      }
      if (name === "pincode") {
        if (branchDetail[name].trim().length !== 0) {
          if (branchDetail[name].toString().length != 6 || !negativeNumberStringValidation(branchDetail[name])) {
            errorDublicate = true
          }
        }
        else
          errorDublicate = true
      }
      if (name == 'country' || name == 'city' || name == 'state') {
        if (branchDetail[name].trim().length !== 0) {
          if (!(/^[a-zA-Z\s]+$/.test(branchDetail[name]))) {
            errorDublicate = true
          }
        }
        else
          errorDublicate = true
      }
      if (name == 'address') {
        if (branchDetail[name].trim().length == 0) {
          errorDublicate = true
        }
      }

      setError(errorDublicate)
    }
  }, [submit])

  return (
    <>
      <span className="det-label">
        {img ?
          <img
            src={require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`)}
            alt="i"
          /> : ''}
        {label}
      </span>
      <input type={`${name == 'pincode' ? 'number' : 'text'}`} placeholder="Empty" className={`text-custom ${submit && error && "errorAlert"}`} value={branchDetail[name]} name={name} onChange={onChangeEnd} />
    </>
  );
}

export default React.memo(Input);
